// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.deposit[data-v-7f8c13fb] {

    position: absolute;

    top: 5.75rem;

    left: 0;

    right: 0;

    z-index: 5;

    cursor: pointer;

    --tw-bg-opacity: 1;

    background-color: rgb(250 237 205 / var(--tw-bg-opacity));

    padding-left: 1rem;

    padding-right: 1rem;

    padding-top: 0.5rem;

    padding-bottom: 0.5rem;

    transition-property: opacity;

    transition-duration: 300ms;

    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1)
}
@media (min-width: 768px) {
.deposit[data-v-7f8c13fb] {

        cursor: default
}
}
@media (min-width: 996px) {
.deposit[data-v-7f8c13fb] {

        position: static
}
}
.deposit__wrapper[data-v-7f8c13fb] {

    margin-left: auto;

    margin-right: auto;

    display: flex;

    max-width: 64rem;

    flex-direction: column;

    gap: 0.5rem
}
@media (min-width: 768px) {
.deposit__wrapper[data-v-7f8c13fb] {

        align-items: center
}
}
@media (min-width: 996px) {
.deposit__wrapper[data-v-7f8c13fb] {

        flex-direction: row;

        justify-content: space-between
}
}
.deposit__wrapper .button[data-v-7f8c13fb] {

    width: 100%
}
@media (min-width: 768px) {
.deposit__wrapper .button[data-v-7f8c13fb] {

        max-width: 18.5rem
}
}
@media (min-width: 996px) {
.deposit__wrapper .button[data-v-7f8c13fb] {

        width: auto;

        max-width: none
}
}
.deposit__text[data-v-7f8c13fb] {

    display: flex;

    flex-direction: column;

    align-items: center;

    justify-content: center;

    text-align: center;

    font-family: Roboto;

    line-height: 1.5;

    font-size: 0.875rem;

    font-weight: 400
}
@media (min-width: 768px) {
.deposit__text[data-v-7f8c13fb] {

        font-family: Roboto;

        line-height: 1.35;

        font-size: 1.125rem;

        font-weight: 400
}
}
@media (min-width: 996px) {
.deposit__text[data-v-7f8c13fb] {

        flex-direction: row;

        align-items: flex-start;

        gap: 0.5rem;

        text-align: left
}
}
.deposit__title[data-v-7f8c13fb] {

    font-family: Roboto;

    line-height: 1.5;

    font-size: 1rem;

    font-weight: 700
}
@media (min-width: 768px) {
.deposit__title[data-v-7f8c13fb] {

        font-family: Mont;

        line-height: 1.35;

        font-size: 1.375rem;

        font-weight: 700
}
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/partials/home/DepositCTA.vue"],"names":[],"mappings":";AAyDA;;IAAA,kBAAA;;IAAA,YAAA;;IAAA,OAAA;;IAAA,QAAA;;IAAA,UAAA;;IAAA,eAAA;;IAAA,kBAAA;;IAAA,yDAAA;;IAAA,kBAAA;;IAAA,mBAAA;;IAAA,mBAAA;;IAAA,sBAAA;;IAAA,4BAAA;;IAAA,0BAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA,iBAAA;;IAAA,kBAAA;;IAAA,aAAA;;IAAA,gBAAA;;IAAA,sBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,mBAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,WAAA;;QAAA;AAAA;AAAA;AAIA;;IAAA,aAAA;;IAAA,sBAAA;;IAAA,mBAAA;;IAAA,uBAAA;;IAAA,kBAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,mBAAA;;QAAA,iBAAA;;QAAA,mBAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,mBAAA;;QAAA,uBAAA;;QAAA,WAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,eAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,iBAAA;;QAAA,iBAAA;;QAAA,mBAAA;;QAAA;AAAA;AAAA","sourcesContent":["<template>\n  <section class=\"deposit\" @click=\"handleClick\">\n    <div class=\"deposit__wrapper\">\n      <div class=\"deposit__text\">\n        <p class=\"deposit__title\">¿Tienes arras o reserva?</p>\n        <p>Consigue una hipoteca en tiempo récord.</p>\n      </div>\n      <Button ref=\"cta\" tag=\"a\" :href=\"route('home.reservation')\" :size=\"size\" btn-style=\"primary\">Hipoteca Exprés</Button>\n    </div>\n  </section>\n</template>\n\n<script>\nimport { onMounted, ref } from '@vue/composition-api';\nimport { onResize } from '@/lego/utils/window/screen';\nimport { getTouchedScreen } from '@/lego/utils/tailwind/screen';\nimport Button from '@/lego/components/buttons/Button.vue';\n\nexport default {\n  components: { Button },\n  setup() {\n    const cta = ref(null);\n    const screen = ref(null);\n    const breakpoints = { xs: 'sm', md: 'lg' };\n    const redirect = { xs: true, md: false };\n    const size = ref('lg');\n\n    const updateSize = () => {\n      screen.value = getTouchedScreen(breakpoints);\n      size.value = breakpoints[screen.value];\n    };\n\n    const handleClick = () => {\n      if (!redirect[screen.value]) {\n        return;\n      }\n      cta.value.click();\n    };\n\n    onMounted(() => {\n      updateSize();\n    });\n    onResize(() => {\n      updateSize();\n    });\n\n    return {\n      cta,\n      size,\n      handleClick,\n    };\n  },\n};\n</script>\n\n<style scoped lang=\"postcss\">\n.deposit {\n  @apply bg-brand-primary-lightest px-xxxs py-nano transition-opacity duration-300 ease-in-out absolute lg:static top-[5.75rem] left-0 right-0 cursor-pointer md:cursor-default z-[5];\n\n  &__wrapper {\n    @apply max-w-5xl mx-auto flex flex-col lg:flex-row lg:justify-between md:items-center gap-nano;\n\n    .button {\n      @apply w-full md:max-w-[18.5rem] lg:w-auto lg:max-w-none;\n    }\n  }\n  &__text {\n    @apply text-center style-overline md:style-body lg:text-left flex flex-col lg:flex-row justify-center items-center lg:items-start lg:gap-nano;\n  }\n  &__title {\n    @apply style-body-sm-bold md:style-subtitle-sm-bold;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
